/**
 * Send Web Vitals metrics to Google Analytics
 * @param {Object} metric - Web Vitals metric object
 */
const sendToAnalytics = (metric) => {
  // Check if gtag is available (Google Analytics loaded)
  if (typeof window !== 'undefined' && window.gtag) {
    // Send metric to Google Analytics as a custom event
    window.gtag('event', metric.name, {
      event_category: 'Web Vitals',
      value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
      event_label: metric.id,
      non_interaction: true,
    });
  }
};

/**
 * Report Web Vitals metrics
 * Tracks all Core Web Vitals and sends them to Google Analytics
 * @param {Function} onPerfEntry - Optional callback for custom handling
 */
const reportWebVitals = (onPerfEntry) => {
  // Import web-vitals library dynamically
  import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
    // Track Cumulative Layout Shift
    getCLS(sendToAnalytics);
    
    // Track First Input Delay
    getFID(sendToAnalytics);
    
    // Track First Contentful Paint
    getFCP(sendToAnalytics);
    
    // Track Largest Contentful Paint
    getLCP(sendToAnalytics);
    
    // Track Time to First Byte
    getTTFB(sendToAnalytics);
    
    // If a custom callback is provided, also call it
    if (onPerfEntry && onPerfEntry instanceof Function) {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    }
  }).catch((error) => {
    // Gracefully handle if web-vitals library fails to load
    console.warn('Failed to load web-vitals library:', error);
  });
};

export default reportWebVitals;
